// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldsEntity from './entities/lds.json';
import ldsMenu from '../pages/lds/menu.json';
import ldsFullForm from '../pages/lds/forms/full.json';
import ldsContextForm from '../pages/lds/forms/context.json';
import ldsMiniForm from '../pages/lds/forms/mini.json';
import ldsLookupForm from '../pages/lds/forms/lookup.json';
import ldsTableView from '../pages/lds/views/table.json';
import ldsStagesView from '../pages/lds/views/stages.json';
import ldsCardsView from '../pages/lds/views/cards.json';
import ldsInlineView from '../pages/lds/views/inline.json';
import ldsBacklogView from '../pages/lds/views/backlog.json';
import ldsSplitView from '../pages/lds/views/split.json';
import ldsCalendarView from '../pages/lds/views/calendar.json';
import ldsDashboardView from '../pages/lds/views/dashboard.json';

/** Тип запису «Чернетка» зі сторінками пакета: меню, форми та подання з pages/lds/. */
export const ldsDefinition: IRecordTypeDefinition = {
  ...ldsEntity,
  views: assembleViewSet({
      table: ldsTableView,
      stages: ldsStagesView,
      cards: ldsCardsView,
      inline: ldsInlineView,
      backlog: ldsBacklogView,
      split: ldsSplitView,
      calendar: ldsCalendarView,
      dashboard: ldsDashboardView,
  }),
  form: ldsFullForm,
  forms: { full: ldsFullForm, context: ldsContextForm, mini: ldsMiniForm, lookup: ldsLookupForm },
  menu: ldsMenu,
} as IRecordTypeDefinition;
